import { render, staticRenderFns } from "./unit-card.vue?vue&type=template&id=4c3cf5ec&"
import script from "./unit-card.vue?vue&type=script&lang=js&"
export * from "./unit-card.vue?vue&type=script&lang=js&"
import style0 from "./unit-card.vue?vue&type=style&index=0&id=4c3cf5ec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports